export enum userFeeDeductionRequestRejectFormFields {
  reviewComment = 'reviewComment',
}
